import { useState } from 'react';
import { Modal, Button, Input, Select } from '../common';
import { ROLE_META } from '../../utils/constants';
import { createUser } from '../../services/userService';

/**
 * Add User Modal
 * Admin/Sales Manager can create new users with specific roles
 */
export function AddUserModal({ isOpen, onClose, showToast, onUserCreated }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "marketer",
    phone: "",
    commission_percentage: null,
  });
  const [submitting, setSubmitting] = useState(false);

  const updateField = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.password) {
      showToast("يرجى ملء جميع الحقول المطلوبة", "error");
      return;
    }

    setSubmitting(true);
    try {
      const newUser = await createUser(formData);
      
      if (newUser) {
        showToast("✅ تم إنشاء الحساب بنجاح");
        
        // If parent provided callback, call it with new user
        if (onUserCreated) {
          onUserCreated(newUser);
        }
        
        // Reset form
        setFormData({
          name: "",
          email: "",
          password: "",
          role: "marketer",
          phone: "",
          commission_percentage: null,
        });
        
        onClose();
      }
    } catch (err) {
      console.error('Error creating user:', err);
      showToast(err.message || '❌ فشل في إنشاء الحساب', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  // Build role options from constants
  const roleOptions = Object.entries(ROLE_META)
    .filter(([key]) => key !== 'admin') // Admin created manually
    .map(([key, meta]) => ({
      value: key,
      label: `${meta.icon} ${meta.label}`,
    }));

  return (
    <Modal 
      title="👤 مستخدم جديد" 
      isOpen={isOpen} 
      onClose={onClose}
      size="md"
    >
      <div style={{ direction: "rtl" }}>
        <Input
          label="الاسم الكامل"
          value={formData.name}
          onChange={e => updateField('name', e.target.value)}
          placeholder="سارة أحمد"
          required
        />

        <Input
          label="البريد الإلكتروني"
          type="email"
          value={formData.email}
          onChange={e => updateField('email', e.target.value)}
          placeholder="sara@gosnel.com"
          required
        />

        <Input
          label="كلمة المرور"
          type="password"
          value={formData.password}
          onChange={e => updateField('password', e.target.value)}
          placeholder="••••••••"
          required
        />

        <Input
          label="رقم الهاتف (اختياري)"
          type="tel"
          value={formData.phone}
          onChange={e => updateField('phone', e.target.value)}
          placeholder="+971 50 123 4567"
        />

        <Select
          label="الدور"
          value={formData.role}
          onChange={e => updateField('role', e.target.value)}
          options={roleOptions}
        />

        {(formData.role === 'marketer' || formData.role === 'rep') && (
          <Input
            label="نسبة العمولة (%) - اختياري"
            type="number"
            value={formData.commission_percentage || ''}
            onChange={e => updateField('commission_percentage', parseFloat(e.target.value) || null)}
            placeholder="15"
          />
        )}

        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
          <Button 
            onClick={handleSubmit} 
            disabled={submitting}
            style={{ flex: 1, justifyContent: "center" }}
          >
            {submitting ? "جاري الإنشاء..." : "إنشاء الحساب"}
          </Button>
          <Button 
            variant="secondary" 
            onClick={onClose}
            disabled={submitting}
            style={{ flex: 1, justifyContent: "center" }}
          >
            إلغاء
          </Button>
        </div>
      </div>
    </Modal>
  );
}
